<template>
  <section class="container">
    <h1 class="title has-text-primary">
      Edit Mission
    </h1>

    <section>

      <b-field label="Mission Name*">
        <b-input class="max-input-width" v-model="mission.name"></b-input>
      </b-field>

      <b-field class="field" label="Mission is Visible to Users in the Missions List?">
        <b-switch v-model="mission.isVisible">
          {{ mission.isVisible ? 'Visible to Users' : 'Hidden' }}
        </b-switch>
      </b-field>

      <b-field class="field" label="Allow Users to Sign Up?">
        <b-switch v-model="mission.isSignUpEnabled">
          {{ mission.isSignUpEnabled ? 'Users Can Sign Up' : 'Sign Up Closed' }}
        </b-switch>
      </b-field>

      <b-field grouped group-multiline>
        <b-field label="From Date*">
          <b-datepicker v-model="mission.fromDate"
                        icon="calendar">
          </b-datepicker>
        </b-field>
        <b-field label="End Date*">
          <b-datepicker v-model="mission.toDate"
                        icon="calendar">
          </b-datepicker>
        </b-field>
      </b-field>

      <b-field grouped group-multiline>
        <b-field label="Country">
          <b-select v-model="mission.country"
                    icon="globe-americas"
                    placeholder="Select Country" required>
            <option v-for="c in listOfCountries"
                    v-bind:key="c">{{c}}
            </option>
          </b-select>
        </b-field>
        <b-field label="Country Description">
          <b-input v-model="mission.countryDescription"></b-input>
        </b-field>
      </b-field>

      <b-field grouped group-multiline>
        <b-field label="Budget">
          <b-input type="number" icon="dollar-sign"
                   v-model="mission.budget"/>
        </b-field>
        <b-field label="Mission Cost">
          <b-input type="number" icon="dollar-sign"
                   v-model="mission.missionCost"/>
        </b-field>
        <b-field label="Donation Fee">
          <b-input type="number" icon="dollar-sign"
                   v-model="mission.donationFee"/>
        </b-field>
      </b-field>

      <h4 class="title is-4">Activities</h4>
      <b-field grouped group-multiline
               v-for="activity in mission.activities"
      >
        <b-field label="Activity">
          <b-input v-model="activity.name"></b-input>
        </b-field>
        <b-field label="Start Date">
          <b-datepicker v-model="activity.startDate"
                        icon="calendar">
          </b-datepicker>
        </b-field>
        <b-field label="End Date">
          <b-datepicker v-model="activity.endDate"
                        icon="calendar">
          </b-datepicker>
        </b-field>
      </b-field>
      <button class="add-more button is-info"
              @click="addMoreActivities">
        Add More Activities
      </button>
      <h4 class="title is-4">Local Contacts</h4>
      <b-field grouped group-multiline
               v-for="localContactInfo in mission.localContactsInfo"
      >
        <b-field label="Type">
          <b-select v-model="localContactInfo.type"
                    icon="user-circle"
                    placeholder="Type" required>
            <option v-for="type in localContactType"
                    v-bind:key="type">{{type}}
            </option>
          </b-select>
        </b-field>
        <b-field label="Title">
          <b-input v-model="localContactInfo.title"></b-input>
        </b-field>
        <b-field label="Name">
          <b-input v-model="localContactInfo.name"></b-input>
        </b-field>
        <b-field label="Profession">
          <b-input v-model="localContactInfo.profession"></b-input>
        </b-field>
        <b-field label="City">
          <b-input v-model="localContactInfo.city"></b-input>
        </b-field>
        <b-field label="Country of Origin">
          <b-select v-model="localContactInfo.countryOfOrigin"
                    icon="globe-americas"
                    placeholder="Select Country" required>
            <option v-for="c in listOfCountries"
                    v-bind:key="c">{{c}}
            </option>
          </b-select>
        </b-field>
        <b-field label="Country Living In">
          <b-select v-model="localContactInfo.countryLivingIn"
                    icon="globe-americas"
                    placeholder="Select Country" required>
            <option v-for="c in listOfCountries"
                    v-bind:key="c">{{c}}
            </option>
          </b-select>
        </b-field>
        <b-field label="Notes">
          <b-input v-model="localContactInfo.notes"></b-input>
        </b-field>
        <b-field label="Skype">
          <b-input v-model="localContactInfo.socialMedia.skype"></b-input>
        </b-field>
        <b-field label="Viber">
          <b-input v-model="localContactInfo.socialMedia.viber"></b-input>
        </b-field>
        <b-field label="Messenger">
          <b-input v-model="localContactInfo.socialMedia.messenger"></b-input>
        </b-field>
        <hr/>
      </b-field>
      <button id="" class="add-more button is-info"
              @click="addMoreLocalContacts">
        Add More Local Contacts
      </button>
    </section>
    <div class="buttons">
      <button class="button is-primary"
              @click="$router.push({ name: 'manage-missions'})">
        Back
      </button>
      <button class="button is-primary" @click="save">Save</button>
    </div>
  </section>
</template>

<script>
import ApiUtil from '@/utils/ApiUtil';
import ListOfCountries from '@/utils/ListOfCountries';
import _ from 'lodash';
import { mapMutations } from 'vuex';

const getExistingLocalContacts = async (mission) => {
  const localContactsId = mission.localContactsId || [];
  const existingContactsInfo = await ApiUtil.getLocalContacts();

  const updatedLocalContactsInfo = localContactsId.map((localContactId) => {
    const localContactInfo = existingContactsInfo[localContactId];
    localContactInfo.localContactId = localContactId;
    return localContactInfo;
  });

  return updatedLocalContactsInfo;
};

const createOrUpdateLocalContacts = async (mission) => {
  const localContactInfoToCreate = _.filter(mission.localContactsInfo, (localContactInfo) => {
    return localContactInfo.localContactId === '' && localContactInfo.name !== '';
  });

  const localContactInfoToUpdate = _.filter(mission.localContactsInfo, (localContactInfo) => {
    return localContactInfo.localContactId !== '' && localContactInfo.name !== '';
  });

  const createLocalContactPromises = localContactInfoToCreate.map((localContactInfo) => {
    const temp = localContactInfo;
    delete temp.localContactId;
    return ApiUtil.createLocalContact(temp);
  });

  const editLocalContactPromises = localContactInfoToUpdate.map((localContactInfo) => {
    return ApiUtil.editLocalContact(localContactInfo.localContactId, localContactInfo);
  });

  const createResponses = await Promise.all(createLocalContactPromises);
  const createLocalContactsId = createResponses.map((response) => {
    return response.data.localContactId;
  });

  const editResponses = await Promise.all(editLocalContactPromises);
  const editLocalContactsId = editResponses.map((response) => {
    return response.data.localContactId;
  });

  const updatedLocalContactsId = createLocalContactsId.concat(editLocalContactsId);
  return updatedLocalContactsId;
};

export default {
  async created() {
    this.setIsLoading(true);
    const missionId = this.$router.currentRoute.params.missionId;
    const mission = await ApiUtil.getMission(missionId);

    mission.fromDate = new Date(mission.fromDate);
    mission.toDate = new Date(mission.toDate);

    const activities = mission.activities || [];
    const updatedActivities = activities.map((activity) => {
      return {
        name: activity.name,
        startDate: new Date(activity.startDate),
        endDate: new Date(activity.endDate),
      };
    });
    mission.activities = updatedActivities;

    const updatedLocalContactsInfo = await getExistingLocalContacts(mission);
    this.setIsLoading(false);

    mission.localContactsInfo = updatedLocalContactsInfo;

    this.mission = mission;
  },
  data() {
    return {
      listOfCountries: ListOfCountries.map((c) => {
        return c.name;
      }),
      localContactType: ['Tour Guide', 'Administrator', 'Resident'],
      mission: {
        missionId: null,
        name: null,
        fromDate: null,
        toDate: null,
        country: null,
        countryDescription: null,
        budget: null,
        missionCost: null,
        donationFee: null,
        isVisible: null,
        isSignUpEnabled: null,
        isArchived: null,
        localContactsId: [],
        localContactsInfo: [],
        activities: [],
      },
    };
  },
  methods: {
    ...mapMutations(['setIsLoading']),
    async save() {
      const { missionId } = this.$router.currentRoute.params;

      this.mission.activities = _.filter(this.mission.activities, (activity) => {
        return activity.name;
      });

      const localContactsId = await createOrUpdateLocalContacts(this.mission);
      delete this.mission.localContactsInfo;
      this.mission.localContactsId = localContactsId;

      await ApiUtil.editMission(missionId, this.mission);
      this.$toast.open('Mission Saved!');
      this.$router.push({ name: 'manage-missions' });
    },
    addMoreActivities() {
      this.mission.activities.push({
        name: '',
        startDate: new Date(),
        endDate: new Date(),
      });
    },
    addMoreLocalContacts() {
      this.mission.localContactsInfo.push({
        localContactId: '',
        name: '',
        city: '',
        countryLivingIn: '',
        countryOfOrigin: '',
        type: '',
        socialMedia: {
          skype: '',
          messenger: '',
        },
      });
    },
  },
};
</script>

<style lang="scss">
  @import '../../common/inputFieldStyles.scss';

  h1 {
    font-weight: bold;
    font-size: 120%;
    margin-bottom: 10px;
  }

  .add-more {
    margin-bottom: 25px;
  }

  hr {
    border: 0;
    clear: both;
    display: block;
    width: 96%;
    background-color: #A9A9A9;
    margin-top: 2px;
    margin-bottom: 20px;
    height: 1px;
  }
</style>
